import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from '../i18n';
import { useCMSContent } from '../hooks/useCMSContent';

interface TermsConditionsModalProps {
  show: boolean;
  onHide: () => void;
}

export default function TermsConditionsModal({ show, onHide }: TermsConditionsModalProps) {
  const { t } = useTranslation();
  const { content, loading } = useCMSContent('terms-conditions', { enabled: show });

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('about.terms_conditions')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('general.loading')}</span>
            </div>
          </div>
        ) : (
          content && (
            <div dangerouslySetInnerHTML={{ __html: content.content }} />
          )
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('general.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
